type Props = {
  lastName: string
  firstName: string
}
export const getFullName = (props: Props) => {
  return `${props.lastName} ${props.firstName}`
}
